import { useEffect } from 'react';

import { useRouter } from 'next/router';

import { tryCatch } from 'utils/errorHandler';

// const INTERCOM_APP_ID = 'ki2hcqzx';

declare global {
  interface Window {
    Intercom?: any;
  }
}

export const IntercomComponent = () => {
  const { pathname } = useRouter();

  const Intercom = typeof window !== 'undefined' ? window.Intercom : undefined;

  useEffect(() => {
    if (Intercom) {
      tryCatch({
        onTry: () => {
          Intercom('update', {
            hide_default_launcher: false,
            last_request_at: new Date().getTime() / 1000,
          });
        },
      });
      const timeout = setTimeout(() => {
        Intercom('update', {
          hide_default_launcher: false,
          last_request_at: new Date().getTime() / 1000,
        });
      });
      return () => {
        clearTimeout(timeout);
      };
    }
  }, [pathname, Intercom]);

  return null;
};
